import Portal from '../atoms/Portal';
import { CheckCircle2, AlertCircle, X } from 'lucide-react';

export default function Toast({
  toasts = [],
  onDismiss,
}) {
  if (!toasts.length) return null;

  return (
    <Portal>
      <div className="toast-container">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`toast toast--${t.type || 'success'}${t.leaving ? ' toast--closing' : ''}`}
          >
            <div className="toast__icon">
              {t.type === 'error' ? <AlertCircle /> : <CheckCircle2 />}
            </div>
            <div className="toast__content">
              {t.title ? <div className="toast__title">{typeof t.title === 'string' ? t.title : String(t.title)}</div> : null}
              {t.message ? <div className="toast__message">{typeof t.message === 'string' ? t.message : String(t.message)}</div> : null}
            </div>
            <button
              onClick={() => onDismiss(t.id)}
              className="toast__close"
              aria-label="Close notification"
            >
              <X size={16} />
            </button>
          </div>
        ))}
      </div>
    </Portal>
  );
}
